export const TENANT_ROUTES = {
  LIST: '/tenants',
  CREATE: '/tenants/create',
  DETAIL: '/tenants/$tenantId',
  EDIT: '/tenants/$tenantId/edit',
} as const;
